import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import SchoolManager from "./App";

Sentry.init({
  dsn: "https://b8cff21cae0902452f634ff9bd65e4ab@o4511102527995904.ingest.us.sentry.io/4511102566924288",
  environment: process.env.NODE_ENV,
  // Tag every error with the Git commit SHA so Sentry can match it to the right release & source maps.
  // REACT_APP_SENTRY_RELEASE is set by Vercel at build time (see Vercel env vars).
  release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  // Don't send PII like IP addresses
  sendDefaultPii: false,
  // Only capture errors in production
  enabled: process.env.NODE_ENV === "production",
  // Filter out noise
  beforeSend(event) {
    // Strip any fields that might contain student/guardian data
    if (event.exception) {
      event.exception.values?.forEach(ex => {
        ex.stacktrace?.frames?.forEach(frame => {
          delete frame.vars;
        });
      });
    }
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode><SchoolManager /></React.StrictMode>);
